import React from "react";
import PropTypes from "prop-types";

import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import PrintDocumentBodyCartItem from "./printDocumentBodyCartItem";
import {IS_LIXIL_UI} from "../../../config";


const PrintDocumentBodyBundledCartItems = (props) => {
  const {styles, cartItem, fabricatorData, locale, cartItems, messages} = props;
  // const fabricatorSettings = fabricatorData.settings;

  const {View, Text} = window.ReactPdfRenderer;

  const bundleProducts = cartItems ? cartItems.filter(cItem => {
    return cItem.bundleParentId && (cItem.bundleParentId === cartItem.id)
  }) : [];

  if (fabricatorData.isAmericanStandard && !IS_LIXIL_UI) {
    // the quoting tool needs to have the bundled products hidden (only for American standard) in the cart and receipt,
    // but still send items through the API to LP.
    return null;
  }

  return (
    <View style={styles.cartItemBundled} wrap={true}>
      <Text style={[styles.cartItemSimilarTitle, styles.cartItemSimilarTitleBundled]}>
        {messages["shoppingCart.bundledItems"]}
      </Text>
      <View style={styles.cartItemSimilarTitlePadding}>
        {bundleProducts.map(bundleCartItem => {
          return <PrintDocumentBodyCartItem locale={locale}
                                            key={bundleCartItem.id}
                                            fabricatorData={fabricatorData}
                                            cartItem={bundleCartItem}
                                            cartItems={cartItems}
                                            messages={messages}
                                            styles={styles}/>
        })}
      </View>
    </View>
  )
};

PrintDocumentBodyBundledCartItems.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  fabricatorData: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentBodyBundledCartItems
